<!--
 * @Description: 确认支付弹框组件
 * @Author: fal
 * @FilePath: \xhlz_pc\src\project\components\payModal.vue
 * @LastEditTime: 2025-09-02 15:15:34
-->
<template>
  <el-dialog class="pay-modal" :visible="dialogVisible" width="360px" top="15%" :show-close="false" append-to-body>
    <div class="modal-content">
      <img src="@/project/assets/pay-icon.png" alt="" class="del-icon" />
      <p class="del-text">{{ text }}</p>
      <div class="button-group">
        <el-button class="cancel-btn" @click="handleCancel">{{ cancelText }}</el-button>
        <el-button class="confirm-btn" type="primary" @click="handleConfirm">{{ confirmText }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'payModal',
  props: {
    text: {
      type: String,
      default: '您确定要支付吗？',
    },
    confirmText: {
      type: String,
      default: '确定',
    },
    cancelText: {
      type: String,
      default: '取消',
    },
  },
  data() {
    return {
      dialogVisible: true,
    };
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm');
    },

    handleCancel() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
.pay-modal {
  :deep(.el-dialog) {
    border-radius: 8px;
    background: url('@/project/assets/del-bg.png') no-repeat center;
    background-size: cover;
    min-height: 203px;
  }

  .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .del-icon {
    position: absolute;
    top: -72px;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
    height: 140px;
  }

  .del-text {
    margin: 24px 24px 26px;
    font-size: 20px;
    font-weight: 800;
    color: #333;
    text-align: center;
  }

  .button-group {
    display: flex;
  }

  .cancel-btn {
    font-size: 20px;
    width: 112px;
    border-radius: 4px;
  }

  .confirm-btn {
    margin-left: 20px;
    font-size: 20px;
    width: 112px;
    border-radius: 4px;
    background-color: #2468f2;
  }
}
</style>
